var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuesryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.5,
    viewBox: "0 0 20 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#34a3dc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.455,19,2,22.5V4A1,1,0,0,1,3,3H21a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1Zm1.69-6.929-.975.563,1,1.732.976-.563A4,4,0,0,0,11,14.874V16h2V14.874A4,4,0,0,0,14.854,13.8l.976.563,1-1.732-.975-.563a4,4,0,0,0,0-2.142l.975-.563-1-1.732-.976.563A4,4,0,0,0,13,7.126V6H11V7.126A4,4,0,0,0,9.146,8.2L8.17,7.634l-1,1.732.975.563a4,4,0,0,0,0,2.142ZM12,13a2,2,0,1,1,2-2A2,2,0,0,1,12,13Z",
    transform: "translate(-2 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuesryIcon);
export default __webpack_public_path__ + "static/media/Quesry_icon.37e7eddf6a5960a58b32394791442327.svg";
export { ForwardRef as ReactComponent };